module.exports = __webpack_public_path__ + "img/header-fr.e00310e7.jpg";